import type { dictionaries } from './dictionaries';

export type Locale = 'zh' | 'it' | 'en';

export const LOCALES: readonly Locale[] = ['zh', 'it', 'en'] as const;

export const LOCALE_LABELS: Record<Locale, string> = {
  zh: '中文',
  it: 'Italiano',
  en: 'English',
};

export type TranslationKey = keyof (typeof dictionaries)['en'];
